import { render, staticRenderFns } from "./form-skill-tag.vue?vue&type=template&id=6790d2e2"
import script from "./form-skill-tag.vue?vue&type=script&lang=js"
export * from "./form-skill-tag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports